import { createSlice } from '@reduxjs/toolkit';

import { CustomLessonInfoModalStoreState } from './typings';

const initialState: CustomLessonInfoModalStoreState = {
    shouldShowModal: false,
};

const slice = createSlice({
    name: 'CUSTOM_LESSON_INFO_MODAL',
    initialState,
    reducers: {
        show: (state) => {
            state.shouldShowModal = true;
        },
        hide: (state) => {
            state.shouldShowModal = false;
        },
    },
});

export const customLessonInfoModalActions = slice.actions;
export const customLessonInfoModalReducer = slice.reducer;
